import Close from '@mollie/ui-assets/icons/utilitarian/Close';
import clsx from 'clsx';
import React, { forwardRef, useState } from 'react';
import { Box } from '../Box';
import { Button } from '../Button';
import { Divider } from '../Divider';
import { Icon } from '../Icon';
import { TagStack } from './TagStack';
import './Tag.css';
function TagButton({ children, className, onClick, disabled, }) {
    return (React.createElement(Button, { unstyled: true, onClick: onClick, className: className, disabled: disabled }, children));
}
const TagComponent = forwardRef(function (props, ref) {
    const { children, className, label, onClick, onDismiss, dismissable, dismissableLabel, disabled, ...rest } = props;
    const TagComponent = onClick ? TagButton : 'div';
    const [hoverDismissable, setHoverDismissable] = useState(false);
    return (React.createElement(Box.Restricted, { ...rest, className: clsx('mollie-ui-tag', {
            'mollie-ui-tag--clickable': onClick,
            'mollie-ui-tag--dismissable': dismissable,
            'mollie-ui-tag--hover-dismissable': hoverDismissable,
        }, className), ref: ref },
        React.createElement(TagComponent, { onClick: onClick, disabled: disabled, className: "mollie-ui-tag-wrapper" },
            label && React.createElement("div", { className: "mollie-ui-tag-label" }, label),
            label && children && React.createElement(Divider, { direction: "vertical" }),
            children && React.createElement("div", { className: "mollie-ui-tag-content" }, children)),
        dismissable && (React.createElement(Button, { unstyled: true, size: "extra-small", className: "mollie-ui-tag-dismiss", "aria-label": dismissableLabel, onClick: (e) => {
                e.stopPropagation();
                onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                setHoverDismissable(false);
            }, disabled: disabled, onPointerEnter: () => {
                setHoverDismissable(true);
            }, onPointerLeave: () => {
                setHoverDismissable(false);
            } },
            React.createElement(Icon, { src: Close })))));
});
TagComponent.displayName = 'Tag';
export const Tag = Object.assign({}, TagComponent, {
    Stack: TagStack,
});
//# sourceMappingURL=Tag.js.map